import { Navigate } from "react-router-dom";
import {
  clearDashboardSession,
  getAuthSession,
} from "../Utils/sessionUtils.js";

const ProtectedRoute = ({ children }) => {
  const { accessToken } = getAuthSession();

  if (!accessToken) {
    clearDashboardSession();
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
